<template>
  <div class="no-data">No data</div>
</template>

<script>
export default {
  name: 'NoData'
};
</script>
